module.exports = {"scan":"กรุณาสแกน QR ทางโทรศัพท์!","download":"ดาวน์โหลดแอป","downloadDes":"แอปสำหรับ iOS และ Android","title":"ดาวน์โหลดแอป AIS Smart CAM","mainland":"App Store","international":"Google Play","tips":"Tips:The Chinese mainland edition is only available for users in the Chinese mainland.Non-chinese mainland users please download the International edition."}


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/app-th.json
// module id = +0eI
// module chunks = 0